import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-attention-info',
  templateUrl: './attention-info.component.html',
})
export class AttentionInfoComponent implements OnInit {
  @Input() attentionText;
  safeContent: SafeHtml;
  isAcmic: boolean;
  hideAlert = false;
  constructor(
    private acmicService: AcmicService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.attentionText);
  }

  onClose(){
    this.hideAlert = true;
  }
}
